// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Y7ZkK","card__initials":"styles_card__initials__ZB_0f","clickEffect":"styles_clickEffect__bQqEj","pulse":"styles_pulse__94j6M"};